import { Text, View } from '@components/primitives';
import { Ionicons } from '@expo/vector-icons';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';

const BPTnCHeader: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <View flexDirection="row" alignItems="center" paddingX={scale(10)} paddingY={scale(8)}>
      <Ionicons name="ios-document-text-sharp" size={24} color={colors.secondary.orchid} />
      <Text color={colors.secondary.orchid} variant="xl-bold" style={{ marginLeft: 8 }}>
        {t('reqTxSheet.tncHeader')}
      </Text>
    </View>
  );
};

export default BPTnCHeader;
